/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationWithdrawRequest as ModelsV3ApplicationApplicationWithdrawRequest } from '../../models/Models/v3/Application/application-withdraw-request';
import { ApplicationWithdrawRequestBaseResponse as ModelsV3ApplicationApplicationWithdrawRequestBaseResponse } from '../../models/Models/v3/Application/application-withdraw-request-base-response';

export interface V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params {
  applicationId: string;
      body?: ModelsV3ApplicationApplicationWithdrawRequest
}

export function v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json(http: HttpClient, rootUrl: string, params: V3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json.PATH, 'post');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationApplicationWithdrawRequestBaseResponse>;
    })
  );
}

v3ApplicationVehicleApplicationIdWithdrawPost$Xml$Json.PATH = '/v3/application/vehicle/{applicationId}/withdraw';
